import * as React from "react";
import { CircularProgress, styled } from "@mui/material";

//region [[ Styles ]]

const MainLoaderView = styled("div")({
  height: "100%",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  padding: 10,
  gap: 10,
});
const ProgressDisplay = styled("div")({
  position: "relative",
  "& img": {
    width: 22,
    height: 22,
    marginTop: -3,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface MainLoaderProps {
  title?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const MainLoader = ({ title }: MainLoaderProps) => {
  return (
    <MainLoaderView>
      <ProgressDisplay>
        <CircularProgress color={"secondary"} style={{ opacity: 0.5 }} />
        <img src={"/kahunIcon.svg"} alt={"Kahun Dialogue"} />
      </ProgressDisplay>
      {title && <div>{title}</div>}
    </MainLoaderView>
  );
};
